const GameFormParameters = [
  'f',
  'a',
  'ln',
  'az',
  'zt',
  'ei',
  'ba',
  'st',
  's',
  'spiel77',
  'super6',
  'gluecksSpirale',
  'plus5',
];

export const URLCleanModes = {
  PUSH: 'push',
  REPLACE: 'replace',
};

export function cleanURLQueryParams(mode: string = URLCleanModes.PUSH): void {
  if (!window?.location?.search?.startsWith('?')) {
    return;
  }
  // preserve tracking params
  const allParams = window.location.search.substring(1).split('&');
  const remainingParams = allParams
    .filter((param) => {
      return !GameFormParameters.includes(
        param.split('=')[0].replace(/([fa])+\d+$/g, '$1')
      );
    })
    .join('&')
    .replace(/&$/, '');

  const newUrl =
    window.location.pathname + (remainingParams ? '?' + remainingParams : '');

  if (mode === URLCleanModes.PUSH) {
    (window as any).history.pushState({}, document.title, newUrl);
  } else {
    (window as any).history.replaceState({}, document.title, newUrl);
  }
}
